import { Box } from '@deity/falcon-ui';
import type { DictDefinition, FieldDefinition, ListDefinition } from '@deity-io/di-data-structure-editor';
import { DefinitionFactory, DefinitionLoader } from '@deity-io/di-data-structure-editor';
import { SchemaContext } from 'contexts/SchemaContext';
import { useContext, useMemo, useState } from 'react';
import type { FC } from 'react';
import ConstraintsContainer from '../FieldEditor/EditConstraints/ConstraintsContainer';
import EditFieldDefaults from '../FieldEditor/EditFieldDefaults';
import FieldInfo from '../FieldEditor/FieldInfo';
import FieldNameEditor from '../FieldEditor/FieldNameEditor';
import FieldTypeEditor from '../FieldEditor/FieldTypeEditor';

interface EditFieldPanelProps {}

const EditFieldContainer: FC<EditFieldPanelProps> = () => {
  const ctx = useContext(SchemaContext);
  const [availableTypes] = useState(() => ['dict', 'list', ...DefinitionFactory.availableFieldTypes()]);
  const isEditable = ctx?.state.locked !== true;
  const fieldInfo = ctx?.helper.getSelectedFieldInfo();

  const schema = useMemo(
    () =>
      fieldInfo
        ? DefinitionLoader.tryLoad<FieldDefinition | DictDefinition | ListDefinition>(
            fieldInfo.name,
            fieldInfo.fieldJson
          )
        : undefined,
    [fieldInfo?.name, fieldInfo?.fieldJson]
  );

  return fieldInfo && schema ? (
    <Box p="md" width="full" css={{ height: '100%' }}>
      <Box p="xs" mb="xs">
        <FieldInfo
          type={'fieldType' in schema ? schema.fieldType.type : schema.coreType}
          fieldName={fieldInfo.name}
          fieldPath={fieldInfo.path}
        />
        <FieldNameEditor fieldName={fieldInfo.name} fieldPath={fieldInfo.path} isEditable={isEditable} />
        <FieldTypeEditor
          type={fieldInfo.settings.type}
          availableTypes={availableTypes}
          fieldPath={fieldInfo.path}
          isEditable={isEditable}
        />
      </Box>
      <EditFieldDefaults path={fieldInfo.path} schema={schema} locked={isEditable !== true} />

      <ConstraintsContainer path={fieldInfo.path} schema={schema} isEditable={isEditable} />
    </Box>
  ) : null;
};

export default EditFieldContainer;
